export const newrelicError = (
  e: unknown,
  customAttributes?: Record<string, unknown>,
) => {
  if (window?.newrelic) {
    window.newrelic.noticeError(e, customAttributes);
  }
};
